import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { defaultActivityFilters } from "../activityFilters"
import { selectStagedFilters, setStagedDate } from "../slice"
import { FilterMenuShell } from "./FilterMenuShell"
import { DateRangePicker } from "features/filters/DateRangePicker"

export const DateFilterView = ({
    onBack,
    onCancel,
    onApply,
}: {
    onBack: () => void
    onCancel: () => void
    onApply: () => void
}) => {
    const dispatch = useAppDispatch()
    const staged = useAppSelector(selectStagedFilters).date

    return (
        <FilterMenuShell
            title="Filter by date"
            onBack={onBack}
            onCancel={onCancel}
            onApply={onApply}
            onClearAll={() => dispatch(setStagedDate(defaultActivityFilters.date))}
            width="w-[420px]"
            bodyClassName="flex flex-col"
        >
            <div className="flex flex-col gap-2 py-1">
                <DateRangePicker
                    value={staged}
                    onChange={(value) => dispatch(setStagedDate(value))}
                />
            </div>
        </FilterMenuShell>
    )
}
